import styled from 'styled-components';

export const Body = styled.div`
  padding: 16px 24px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const SectionLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const SectionDescription = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const RadioGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const RadioOption = styled.button<{ selected: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid ${({ theme, selected }) =>
    selected ? theme.colors.primary.primary : theme.colors.surface.surfaceOutline};
  border-radius: 6px;
  padding: 10px 12px;
  background: ${({ theme, selected }) =>
    selected
      ? `color-mix(in srgb, ${theme.colors.primary.primaryHover}, ${theme.colors.surface.surface})`
      : theme.colors.surface.surface};
  cursor: pointer;
  text-align: left;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .ant-radio-wrapper {
    margin-inline-end: 0;
    font-size: 12px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
  }

  .ant-radio {
    top: 0;
  }
`;

export const RadioLabel = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

export const StatCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 12px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};
  border-radius: 6px;
`;

export const StatValue = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.primary.primary};
`;

export const StatLabel = styled.div`
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const InfoBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background-color: ${({ theme }) => theme.colors.primary.primaryContainer};
  border: 1px solid ${({ theme }) => theme.colors.primary.primary};
  border-radius: 6px;
`;

export const InfoIcon = styled.span`
  font-size: 16px;
  line-height: 20px;
  flex-shrink: 0;
`;

export const InfoText = styled.div`
  flex: 1;
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const SuccessBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 32px 24px;
  text-align: center;
`;

export const SuccessTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.success.success};
`;

export const SuccessDescription = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const FooterDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
`;
